angular.module('elfium').service('contactService', ['$q', '$uibModal', 'elfiumRestService', 'elfiumUrlService', 'elfiumConvertFieldTypesFilter', 'CONTACT_FIELD_TYPES',
    function ($q, $uibModal, elfiumRestService, elfiumUrlService, elfiumConvertFieldTypesFilter, CONTACT_FIELD_TYPES) {
        var that = this;
        that.getContacts = function ()  {
            return elfiumRestService.getContacts().then(that._convertFieldTypes);
        };
        that.getContact = function (contactId)  {
            return elfiumRestService.getContact(contactId).then(that._convertFieldTypes);
        };
        that.upsertContact = function (contact) {
            if (contact.id) {
                return elfiumRestService.updateContact(contact);
            } else {
                return elfiumRestService.createContact(contact);
            }
        };
        that.searchContacts = function (searchParameters) {
            return elfiumRestService.searchContacts(searchParameters).then(that._convertFieldTypes);
        };
        that.deleteContact = function (contactId) {
            return elfiumRestService.deleteContact(contactId);
        };
        that._convertFieldTypes = function (contacts) {
            return $q.when(elfiumConvertFieldTypesFilter(CONTACT_FIELD_TYPES, contacts));
        };
        that.openContactDetailModal = function (contactId) {
            var modalInstance = $uibModal.open({
                templateUrl:  elfiumUrlService.getTemplateUrl('contact', 'contactDetailModal'),
                controller: 'contactDetailModalController',
                resolve: {
                    contactId: function () {
                        return contactId;
                    }
                }
            });
            return modalInstance.result;
        };
        that.openDeleteConfirmationModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: elfiumUrlService.getTemplateUrl('elfium', 'elfiumDeleteConfirmationModal'),
                size: 'sm'
            });
            return modalInstance.result;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/contact/contactService.ts